import React from 'react';

type KnownErrorBoundaryContextValue = (error: any) => boolean;

export const KnownErrorBoundaryContext: React.Context<KnownErrorBoundaryContextValue> =
	React.createContext<KnownErrorBoundaryContextValue>(() => false);

KnownErrorBoundaryContext.displayName = 'KnownErrorBoundaryContext';
